/* DermaPharma Content Fix v3 - Cleaned */
(function() {
  'use strict';
  
  function fixContent() {
    // 1. Fix text: $999 -> $1,999
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while (node = walker.nextNode()) {
      var text = node.nodeValue;
      if (false) { // DISABLED: no longer reverting $999
        // node.nodeValue — disabled
      }
    }
    
    // 2. REMOVED: No longer hiding .page-announcement (orange bar is wanted)
    // 3. REMOVED: No longer hiding .section-columns (trust badges need to show)
    // 4. REMOVED: No longer hiding hero text overlay (hero slides have their own text)
  }
  
  fixContent();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixContent);
  }
  setTimeout(fixContent, 500);
  setTimeout(fixContent, 1500);
  
  var observer = new MutationObserver(fixContent);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { observer.disconnect(); }, 10000);
})();
